import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeleteMilletToFotoboxesMutation,
  useSendMilletToFotoboxesMutation,
} from '../../../../core/api/BuffetMilletApi'

export const useUpdateMilletStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const { deletedItems, addedItems } = setEdgeServers(oldValue, newValue) || {}
  const [sendMilletToFotoboxes] = useSendMilletToFotoboxesMutation()
  const [deleteMilletToFotoboxes] = useDeleteMilletToFotoboxesMutation()

  const onUpdateStation = (milletsGuids: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deleteMilletToFotoboxes({
        milletsGuids: [milletsGuids],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendMilletToFotoboxes({
        milletsGuids: [milletsGuids],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
